<div class="mat-typography">
    <p *ngIf="process.isIndexing">Index Parcels from State Layer: {{ process.indexStateLayerPRs }}</p>
    <p *ngIf="process['zoningCodeRecords'] !== undefined">Zoning code records: {{ process.zoningCodeRecords }}</p>
    <p *ngIf="process['totalPropertyRecords'] !== undefined">Total property records: {{
        process.totalPropertyRecords | number }}</p>
    <p *ngIf="process['currentExpectedRecords'] !== undefined">Property records left: {{
        process.currentExpectedRecords }}</p>
    <p *ngIf="process.isIndexing">Current index position: {{ process.currentOffset }}</p>
    <p *ngIf="process['progress'] !== undefined">Progress: {{ process.progress }}%</p>
    <p *ngIf="process['emptyResultAttempts'] !== undefined">Failed calculation requests:
        {{ process.emptyResultAttempts | number }}
    </p>
    <p *ngIf="process.isIndexing">Currently received records: {{ process.receivedRecords }}
    </p>
    <p *ngIf="process['maxThreadsCount'] !== undefined">Max threads count: {{ process.maxThreadsCount }} </p>
    <p *ngIf="process['activeThreadsCount'] !== undefined">Active threads count: {{ process.activeThreadsCount }} </p>
    <p *ngIf="process['zoningCodeId'] !== undefined && !process.isIndexing && !process.isCalculation">Zoning Code Id: {{
        process.zoningCodeId }} </p>
    <p *ngIf="process['zoningCodeStatus'] !== undefined && !process.isIndexing && !process.isCalculation">Zoning Code
        Status: {{
        getPrettyZCStatus(process.zoningCodeStatus) }} </p>
</div>